module.exports = __webpack_public_path__ + "assets/bgOzon.e0b65452bca613cc2ff0459cf503d08a4a5c41e423b21d390365119a5e818e20.jpg";